import MdfeSchema from './schemas/MdfeSchema';
import ListMdfes from './pages/ListMdfes';
import CreateMdfe from './pages/CreateMdfe';

export default [
  {
    path: MdfeSchema.routes.list.path,
    name: MdfeSchema.routes.list.name,
    component: ListMdfes,
    meta: MdfeSchema.routes.list.meta,
  },
  {
    path: MdfeSchema.routes.create.path,
    name: MdfeSchema.routes.create.name,
    component: CreateMdfe,
    meta: MdfeSchema.routes.create.meta,
  },
  {
    path: MdfeSchema.routes.show.path,
    name: MdfeSchema.routes.show.name,
    component: CreateMdfe,
    meta: MdfeSchema.routes.show.meta,
  },
];
